import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";

import "./css/ErrorPage.scss";

const ErrorPage = () => {
  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);

  window.addEventListener("resize", function () {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  });

  const navigate = useNavigate();
  return (
    <>
      <div
        className='error-page'
        style={{
          height: height - 75,
          width: width,
        }}
      >
        <div className='error-msg'>
          <h1>Oops, something went wrong.</h1>
          <div>
            Sorry about that. Please go
            <span
              onClick={() => {
                navigate(-1);
              }}
            >
              back
            </span>
            and try to make another request.
          </div>
        </div>
        <Footer args={{ height, width }} />
      </div>
    </>
  );
};

export default ErrorPage;
